import React from 'react';
import { FiFileText, FiList, FiShoppingCart } from 'react-icons/fi';

const workflowItems = [
  {
    key: 'quotation',
    label: 'Solicitar cotización',
    description: 'Consulta antes de comprar',
    path: '/client-portal/request',
    icon: FiFileText,
  },
  {
    key: 'purchase-order',
    label: 'Crear orden de compra',
    description: 'Pedido para comprar',
    path: '/client-portal/purchase-orders/new',
    icon: FiShoppingCart,
  },
  {
    key: 'orders',
    label: 'Mis órdenes',
    description: 'Seguimiento de pedidos',
    path: '/client-portal/purchase-orders',
    icon: FiList,
  },
];

const ClientPortalWorkflowNav = ({ activeKey, onNavigate, className = '' }) => (
  <nav
    className={`grid grid-cols-1 gap-2 sm:grid-cols-3 ${className}`}
    aria-label="Secciones del portal cliente"
  >
    {workflowItems.map((item) => {
      const Icon = item.icon;
      const isActive = activeKey === item.key;
      return (
        <button
          key={item.key}
          type="button"
          onClick={() => onNavigate?.(item.path)}
          aria-current={isActive ? 'page' : undefined}
          className={`flex min-h-[74px] items-center gap-3 rounded-lg border px-4 py-3 text-left transition ${
            isActive
              ? 'border-blue-600 bg-blue-600 text-white shadow-sm'
              : 'border-gray-200 bg-white text-gray-700 hover:border-blue-300 hover:bg-blue-50'
          }`}
        >
          <span
            className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full ${
              isActive ? 'bg-white/15 text-white' : 'bg-gray-100 text-blue-700'
            }`}
          >
            <Icon size={20} />
          </span>
          <span className="min-w-0">
            <span className="block text-sm font-semibold leading-tight">
              {item.label}
            </span>
            <span className={`mt-1 block text-xs leading-tight ${isActive ? 'text-blue-50' : 'text-gray-500'}`}>
              {item.description}
            </span>
          </span>
        </button>
      );
    })}
  </nav>
);

export default ClientPortalWorkflowNav;
